const swiper = new Swiper('.swiper', {
    loop: true,
    slidesPerView: 1,
    centeredSlides: true,
    effect: "creative",
    creativeEffect: {
        prev: {
            shadow: true,
            translate: ["100%", 0, 0],
        },
        next: {
            translate: [0, 0, -400],
        },
    },
    autoplay: {
        delay: 5000,
        disableOnInteraction: true,
    },
    lazy: true,
    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

const boxBorderSwiper = new Swiper('.box-border-slider', {
    loop: true,
    slidesPerView: 1,
    spaceBetween:50,
    centeredSlides: true,
    autoplay: {
        delay: 5000,
        disableOnInteraction: true,
    },
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

AOS.init();
